import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareM = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler13') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler13', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Fish sack!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Fish sack!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareM}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareM
